import { Reducer } from 'redux';

import { HIDE_NOTIFICATION, NotificationActionTypes, NotificationState, SHOW_NOTIFICATION } from './types';

const defaultState: NotificationState = {
  message: '',
  displayType: 'default',
  cta: null,
};

const reducer: Reducer<NotificationState, NotificationActionTypes> = (
  state: NotificationState = defaultState,
  action: NotificationActionTypes,
): NotificationState => {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return {
        ...state,
        message: action.message,
        displayType: action.displayType || state.displayType,
        cta: action.cta,
      };
    case HIDE_NOTIFICATION:
      return defaultState;
    default:
      return state;
  }
};

export default reducer;
